<template>
  <div class='thbfx-wrap'>
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{data:timeType}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
            <el-select v-model="option" placeholder="请选择" class="option">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </time-search>
        </div>
        <div class="grid-content">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <div class="main">
            <div class="header">
              趋势图分析
            </div>
            <div class="main-body">
              <div class="echarts" :id="id" v-resize="resize"></div>
              <div class="tab-main" v-show="showTable">
                <div class="tab-small">
                  <el-radio-group size="small" v-model="tabSelectedIndex">
                    <el-radio-button :label="index" v-for="(item,index) in tablesData" :key="index">{{item.label}}</el-radio-button>
                  </el-radio-group>
                  <i class="el-icon-circle-close" @click="showTable = false"></i>
                </div>
                <div class="table-div">
                  <nk-table v-if="tablesData.length > 0" :data="tablesData[tabSelectedIndex].data" :columns="tablesData[tabSelectedIndex].columns" :border="false"></nk-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import uuidv1 from 'uuid/v1'
import TabTree from '@/components/common/TabTree.vue'
import { findDataByParam } from '@/utils/index.js'
import TimeSearch from '@/components/common/TimeSearch.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
import echarts from 'echarts'
import { TAB_UNIT_MAP } from '@/config/index.js'
import dateTool from '@/utils/dateTool.js'
import NkTable from '@/components/common/NkTable.vue'
export default {
  props: {
    type: {
      type: String,
      default: '0',
    },
    timeType: {
      type: Array,
      default: [
        { type: 'day', label: '日' },
        { type: 'month', label: '月' },
        { type: 'year', label: '年' },
      ],
    },
    treeAddress: {
      type: String,
      default: '/analysis/tbfx',
    },
  },
  data () {
    return {
      viewTreeData: [], //树数据
      selectedMeasure: {
        //当前选中的树数据
        measureId: '',
        measureName: '',
      },
      timeElem: {}, //当前的时间参数
      tabShow: true, //左边的树是否显示
      option: '100229', //当前数据类型项
      options: [
        //数据类型
        { value: '100229', label: '正向有功总电能', unit: 'kWh' },
        { value: '100230', label: '反向有功总电能', unit: 'kWh' },
        { value: '100231', label: '正向无功总电能', unit: 'kvar.h' },
        { value: '100232', label: '反向无功总电能', unit: 'kvar.h' },
        { value: '100401', label: '总正向流量', unit: 'm³' },
        { value: '100402', label: '总反向流量', unit: 'm³' },
      ],
      id: uuidv1(), //随机ID
      showTable: false, //是否显示数据视图
      tablesData: [],
      tabSelectedIndex: 0, //当前表格标签卡位置
    }
  },
  components: {
    TabTree,
    TimeSearch,
    BtnShow,
    NkTable,
    ResizeContainer,
  },
  mounted () {
    // this.getTreeData();//获取树数据
    this.fillEcharts() //填充默认echarts
  },
  methods: {
    changeCompany (companId) {
      this.getTreeData(companId)
    },
    async getTreeData (companId) {
      //获取树数据
      let res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        companId,
        this.treeAddress,
        null
      )
      this.viewTreeData = findDataByParam('viewTree', true, res.data) //数据赋值
    },
    async getData () {
      //根据参数获取数据
      let hTime
      if (this.type == '0') {
        //同比时间
        hTime = dateTool.getCheckBeforeTime(
          this.timeElem.startTime,
          this.timeElem.endTime,
          this.timeElem.dateType
        ) //获得同期时间
      } else {
        hTime = dateTool.getLinkRatioDate(
          this.timeElem.dateType,
          this.timeElem.startTime,
          this.timeElem.endTime
        ) //获得环期时间
      }
      let proArr = [
        this.$api.quantity.getQuantityHour(
          this.selectedMeasure.measureId,
          this.timeElem.startTime,
          this.timeElem.endTime,
          this.option,
          this.pointNumber,
          0
        ), //当前时间的数据
        this.$api.quantity.getQuantityHour(
          this.selectedMeasure.measureId,
          hTime.startTime,
          hTime.endTime,
          this.option,
          this.pointNumber,
          0
        ), //同比或环比的数据
      ]
      let result = await Promise.all(proArr)
      let analysisChartObj = {
        startTime: this.timeElem.startTime,
        endTime: this.timeElem.endTime,
        measureName: this.selectedMeasure.measureName,
        measureId: this.selectedMeasure.measureId,
        searchType: 'hour',
        tabType: 'ele',
        timeType: this.timeElem.dateType,
      }
      this.setQoqSeries(
        result,
        'ele',
        this.selectedMeasure.measureName,
        [
          analysisChartObj,
          {
            startTime: hTime.startTime,
            endTime: hTime.endTime,
          },
        ],
        this.timeElem.dateType
      )
    },
    setQoqSeries (data, tabType, measureName, dateArr, timeType) {
      let series = []
      let maxMinTable = []
      let legendData = []
      let timeObj = dateTool.createXAxisObj(
        timeType,
        dateArr[0].startTime,
        dateArr[0].endTime
      )
      let qoqTimeObj = dateTool.createXAxisObj(
        timeType,
        dateArr[1].startTime,
        dateArr[1].endTime
      )
      let xAxisObj =
        Object.keys(qoqTimeObj.timeObj) > Object.keys(timeObj.timeObj)
          ? qoqTimeObj.timeObj
          : timeObj.timeObj
      let xAxisData = []
      for (let key in xAxisObj) {
        xAxisData.push(key)
      }
      for (let i = 0; i < data.length; i++) {
        const element = data[i]
        let xObj = JSON.parse(JSON.stringify(xAxisObj))
        let xObjValueData = []
        for (let j = 0; j < element.data.length; j++) {
          xObj[
            dateTool.format(new Date(element.data[j].time), timeObj.format)
          ] = element.data[j].value.toFixed(2)
        }
        for (let index in xObj) {
          xObjValueData.push(xObj[index])
        }
        legendData.push(dateArr[i].startTime + '~' + dateArr[i].endTime)
        let format = ''
        if (timeType == 'day') {
          format = 'yyyy年MM月dd日'
        } else if (timeType == 'month') {
          format = 'yyyy年MM月'
        } else {
          format = 'yyyy年'
        }
        let name = dateTool.format(new Date(dateArr[i].startTime), format)
        series.push({
          data: xObjValueData,
          name: name,
          type: 'line',
          markPoint: {
            data: [
              { type: 'max', name: '最大值' },
              { type: 'min', name: '最小值' },
            ],
          },
          lineStyle: {
            width: 3,
          },
          markLine: {
            data: [],
          },
        })
      }
      this.charts.setOption({
        tooltip: {
          trigger: 'axis',
          confine: true,
          textStyle: {
            align: 'left',
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#bcbdbe',
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#bcbdbe',
            },
          },
          data: xAxisData,
        },
        // yAxis: { name: TAB_UNIT_MAP[tabType] },
        yAxis: { name: this.options.find(it => it.value === this.option).unit },
      })
      let option = this.charts.getOption()
      option.series = series
      this.charts.setOption(option, true)
    },
    tabTreeDefault (e) {
      //首次加载树时执行，保留默认的树选择
      this.selectedMeasure = e
      this.getData() //获取数据
    },
    tabTreeClick (e) {
      //树节点点击的时候触发
      this.selectedMeasure = e
      this.getData() //获取数据
    },
    timeControlChange (e) {
      //时间下拉框切换时触发
      this.timeElem = e
    },
    TimeControlClick (e) {
      //时间点击查询时
      this.timeElem = e
      this.getData()
    },
    fillEcharts () {
      this.charts = echarts.init(document.getElementById(this.id))
      let option = {
        legend: {
          textStyle: {
            color: '#bcbdbe',
          },
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#bcbdbe',
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#bcbdbe',
            },
          },
        },
        grid: {
          x: 80,
          y: 45,
          x2: 80,
          y2: 80,
        },
        dataZoom: [
          {
            type: 'inside',
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: 'slider',
            width: '90%',
            left: 'center',
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {},
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: (opt) => {
                this.setTableData(opt)
                this.showTable = !this.showTable
                return null
              },
            },
            magicType: {
              type: ['line', 'bar'],
            }, //切换为折线图，切换为柱状图
          },
        },
        yAxis: {
          type: 'value',
          name: 'A',
          nameTextStyle: {
            //y轴上方单位的颜色
            color: '#878b97',
          },
          scale: true /*按比例显示*/,
          axisLine: {
            lineStyle: {
              color: '#bcbdbe',
              width: 2,
            },
          },
          axisLabel: {
            textStyle: {
              color: '#bcbdbe',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#bcbdbe'],
              width: 1,
              type: 'solid',
            },
          },
        },
        tooltip: {
          trigger: 'axis',
          color: '#bcbdbe',
          confine: true,
          textStyle: {
            align: 'left',
          },
        },
        color: [
          '#F0E68C',
          '#008000',
          '#FF0000',
          '#5af4ce',
          '#d050ff',
          '#CD5C5C',
          '#4DCD53',
          '#F1AB27',
          '#B96CD3',
        ],
        series: [],
      }
      this.charts.setOption(option)
    },
    resize () {
      this.charts && this.charts.resize()
    },
    setTableData (opt) {
      let series = opt.series
      let tablesData = []
      for (let i = 0; i < series.length; i++) {
        let columns = [
          { prop: 'time', label: '时间', sortable: true, show: true },
          { prop: 'val', label: series[i].name, show: true },
        ]
        let data = []
        for (let j = 0; j < series[i].data.length; j++) {
          const obj = series[i].data[j]
          if (opt.xAxis[0].type === 'time') {
            data.push({ time: obj[0], val: obj[1] })
          } else {
            data.push({ time: opt.xAxis[0].data[j], val: obj })
          }
        }
        tablesData.push({
          columns: columns,
          data: data,
          align: 'right',
          label: series[i].name,
        })
      }
      this.tablesData = Object.assign([], tablesData)
    },
  },
  beforeDestroy () {
    this.charts.clear()
  },
}
</script>

<style lang='scss' scoped>
.thbfx-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 100%;
    margin-right: 14px;
  }
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      bottom: 0;
      width: 100%;
      top: 50px;
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      box-sizing: border-box;
      .main {
        width: 100%;
        height: 100%;
        position: relative;
        .header {
          width: 100%;
          height: 44px;
          background: #63a8eb;
          border: 1px solid #63a8eb;
          border-bottom: none;
          box-sizing: border-box;
          border-radius: 4px 4px 0 0;
          font-size: 18px;
          font-weight: bold;
          line-height: 44px;
          text-align: left;
          padding-left: 10px;
        }
        .main-body {
          width: 100%;
          position: absolute;
          top: 44px;
          bottom: 10px;
          border: 1px solid #dedee1;
          box-sizing: border-box;
          padding: 0 14px 14px;
          border-radius: 0 0 4px 4px;
          border-top: none;
          .echarts {
            width: 100%;
            height: 100%;
          }
          .tab-main {
            position: absolute;
            top: 0;
            left: 0px;
            right: 0px;
            bottom: 0px;
            background: #fff;
            overflow-y: auto;
            .tab-small {
              width: 100%;
              height: 40px;
              text-align: left;
              display: flex;
              align-items: center;
              .el-radio-group {
                flex: 1;
                padding-left: 10px;
                box-sizing: border-box;
              }
              .el-icon-circle-close {
                padding: 0px 10px;
                font-size: 20px;
                cursor: pointer;
                color: #2e3842;
              }
            }
          }
        }
      }
    }
  }
}
</style>